/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { css } from "@emotion/react";
import { IconButton as MdIconButton } from "@rmwc/icon-button";
import "@rmwc/icon-button/styles";
import Svg from "../../../Image/Svg";
import { ThemePropT } from "@rmwc/types";
import { Size } from "../../../..";

export type IconButtonTypes = {
  icon?: any;
  // onIcon?: any;
  onClick?: Function;
  onChange?: Function;
  iconSize?: Size;
  iconColor?: ThemePropT;
  disableRipple?: boolean;
  type?: string;
};

const IconButton: FC<IconButtonTypes> = (props) => {
  const { icon, onClick, iconSize, iconColor, disableRipple = false, onChange, type } = props;

  let iconHover;
  if (disableRipple) {
    iconHover = "none";
  } else {
    iconHover = "";
  }

  let dimension;
  switch (iconSize) {
    case "xsmall":
      dimension = "16px";
      break;
    case "small":
      dimension = "18px";
      break;
    case "medium":
      dimension = "24px";
      break;
    case "large":
      dimension = "40px";
      break;
    case "xlarge":
      dimension = "60px";
      break;
  }

  const handleClick = () => onClick && onClick();
  const handleChange = () => onChange;
  const styles = css`
    ::before,
    ::after {
      content: ${iconHover};
    }
    svg,
    img {
      width: ${dimension};
      height: ${dimension};
    }
  `;
  return (
    <MdIconButton
      css={styles}
      icon={<Svg icon={icon} size={iconSize} theme={iconColor} />}
      onClick={handleClick}
      type={type}
      onChange={handleChange}
    />
  );
};

export default IconButton;
